<template>
    <v-layout row>
        <button v-for="item in config" :key="`option-button__${typeIndex}__${item.key}`" @click="handleChange(typeIndex, item.id)" class="option-button" :class="{'option-button--active': item.id === value}">
            {{ item.key }}
        </button>
    </v-layout>
</template>

<script>
export default {
    name: 'OptionButtons',
    props: {
        config: {
            type: Array,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        typeIndex: {
            type: Number,
            required: true
        },
        handleChange: {
            type: Function,
            required: true
        }
    }
}

</script>

<style lang="scss" scoped>
.option-button {
    background: $light-gray;
    color: $secondary-default;
    border: 1px solid $secondary-default;
    padding: 0 35px;
    outline: none;
    margin-bottom: 20px;

    &:first-child {
        border-top-left-radius: 3em;
        border-bottom-left-radius: 3em;
    }

    &:last-child {
        border-top-right-radius: 3em;
        border-bottom-right-radius: 3em;
    }

    &--active {
        background: $secondary-default;
        color: $light-gray;
    }
}
</style>
